import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, useAuth, Icon } from '@iq/react-components';
import AppContext from '../../AppContext';
import ThemeSwitch from '../ThemeSwitch';

const UserInfo = () => {
  const { theme, setTheme } = useContext(AppContext);
  const darkMode = theme === 'dark';
  const ref = useRef(null);
  const [showPanel, setShowPanel] = useState(false);

  const {
    profile: { name, email },
    logOut,
  } = useAuth();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setTimeout(() => {
          setShowPanel(false);
        }, 0);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggleOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setShowPanel((previous) => !previous);
  };

  const onDarkModeToggle = () => {
    const next = !darkMode;
    setTheme(next ? 'dark' : 'light');
  };

  return (
    <div ref={ref}>
      <Button
        design="text"
        tooltip="User Info"
        className="user-avatar-button"
        onClick={handleToggleOpen}
      >
        <Icon icon="he-user" />
      </Button>

      {showPanel && (
        <div className="user-info-panel">
          <div className={'user-info-section'}>
            <div className="user-info">
              <div className="user-avatar">
                <Button
                  design="text"
                  className={'user-avatar-button'}
                >
                  <div>
                    <Icon icon="he-user" />
                  </div>
                </Button>
              </div>
              <div className="user-name">
                <span>{name || email}</span>
              </div>
              {email && (
                <div className="user-email">
                  <span>{email}</span>
                </div>
              )}
            </div>
            <div className="user-info-actions">
              <div
                className="logout-button"
                onClick={logOut}
              >
                <Icon icon="he-logout" />
                <span>Sign off</span>
              </div>

              <ThemeSwitch
                onChange={onDarkModeToggle}
                nightmode={darkMode}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInfo;
